export default "/images/d35adcc99569e841f19eaf37e9908978.avif";